var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"my-home"},[_c('div',{staticClass:"container flex-between"},[_c('mySideBar'),_c('router-view',{staticClass:"my-router-view"})],1)])}
var staticRenderFns = []

export { render, staticRenderFns }